module.exports = "/_next/static/images/8b5888b820725e2233aab14a82da889f-nuconta-inclined-device@1x.png";